<div
  class="access-code"
  [class.access-code-sm]="size === 'small'"
  [class.access-code-md]="size === 'medium'"
  [class.access-code-lg]="size === 'large'"
  [class.access-code-light]="!darkMode"
  [class.access-code-dark]="darkMode"
>
  @for (digit of value; track $index) {
    <span>{{ digit }}</span>
  }
</div>
